import { getAnonymousId } from 'utils/segment';

/** This input is used by some Google Tag Manager tags, which pull
 * the value out of this input and pass it through marketing integrations */
const ChimeAnonymousIdHiddenInput = () => {
  const anonymousId = getAnonymousId();

  return (
    <input id="chime-uid" name="chime-uid" type="hidden" value={anonymousId} />
  );
};

export default ChimeAnonymousIdHiddenInput;
